import { CoreAPI, createAPIMethod } from '@hero/sdk-core';
import { DriverGetOneAPI, DriverGetAllCarrierAPI } from '@hero/api';

export function createDriversAPI(coreAPI: CoreAPI) {
  return {
    /**
     * Get a single driver by ID
     *
     * API: {@link DriverGetOneAPI}
     */
    getOne: createAPIMethod<DriverGetOneAPI>(coreAPI, 'driver.getOne'),

    /**
     * Get carrier drivers (returns Driver[] directly)
     *
     * API: {@link DriverGetAllCarrierAPI}
     */
    getCarrierDrivers: createAPIMethod<DriverGetAllCarrierAPI>(coreAPI, 'driver.getCarrierDrivers'),
  };
}
